import React from "react";
import { Link } from "react-router-dom";
import IndexPage from "./IndexPage";

const LoginRecoveryPage = () => (
  <>
    <div className="container pt-3">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="alert alert-info" role="alert">
            ระบบอัปเดตความปลอดภัยแล้ว กรุณาลองเข้าสู่ระบบอีกครั้ง
            หากกำลังสมัครสมาชิก กรุณาเริ่มสมัครใหม่
            <div className="d-flex gap-3 mt-2">
              <Link to="/">เข้าสู่ระบบ</Link>
              <Link to="/">เริ่มสมัครสมาชิกใหม่</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <IndexPage />
  </>
);

export default LoginRecoveryPage;
